import { render, staticRenderFns } from "./DgoHome.vue?vue&type=template&id=3f3db67e&scoped=true"
import script from "./DgoHome.vue?vue&type=script&lang=js"
export * from "./DgoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3db67e",
  null
  
)

export default component.exports